<script lang="ts">
	import { LinkIcon } from '../../../assets/icons/LinkIcon';
	import { UploadIcon } from '../../../assets/icons/UploadIcon';
	import { isMobileDevice } from '../../../utils/isMobileDevice';
	import type { DialogStores } from '../../Dialog';
	import { Txt } from '../../Txt';

	interface Props {
		dataCy: string;
		supportedFormats: string;
		dialogStores: DialogStores;
		enableUrlDialog?: boolean;
	}

	let { dataCy, supportedFormats, dialogStores, enableUrlDialog = false }: Props = $props();

	const handleClickEnterLink = (e: Event) => {
		e.stopPropagation();
		dialogStores.states.open.set(true);
	};
</script>

<div class="mb-2.5 flex gap-4">
	<UploadIcon />
	{#if enableUrlDialog}
		<LinkIcon />
	{/if}
</div>

{#if !isMobileDevice()}
	<Txt variant="label3" class="mb-2.5 text-center"
		>Drag and drop file here or <span class="text-blue-400 underline" data-cy={`${dataCy}-browse`}
			>browse</span
		>{#if enableUrlDialog}&nbsp;or&nbsp;<button type="button" onclick={handleClickEnterLink}
				><span class="text-blue-400 underline" data-cy={`${dataCy}-enter-link`}>enter a URL</span
				></button
			>{/if}
	</Txt>
{:else}
	<Txt variant="label3" class="mb-2.5"
		>Tap to <span class="text-blue-400 underline" data-cy={`${dataCy}-browse`}
			>upload your file</span
		></Txt
	>
{/if}

<Txt variant="body3" class="text-gray-500">Supported formats: {supportedFormats}</Txt>
